import React, { useState, useEffect } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../../../styles/customScrollbar.css";
import { useParams, useNavigate } from "react-router-dom";
import { ContentsService } from "services/ContentsService";
import { Content as ContentType } from "types/types";

const ReceiptData = () => {
  const { id } = useParams();
  const [contentData, setContentData] = useState<ContentType | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  const handleEducationContent = (id: string) => {
    navigate(`/review-education-content/${id}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await ContentsService.getContentById(id);
        // console.log("dataaa", data);

        setContentData(data as ContentType);
      } catch (error) {
        console.error("Error fetching content data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100vw"
      >
        <CircularProgress color="primary" />
      </Box>
    );

  if (!contentData) return <Typography>No data found for this content.</Typography>;

  return (
    <Box sx={styleSheet.mainContainer}>
      <Box sx={styleSheet.container}>
        <Box
          onClick={handleBack}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            cursor: "pointer",
          }}
        >
          <CloseIcon sx={{ color: "#233F91" }} />
        </Box>
        <Box sx={styleSheet.boxContainer}>
          <Box>
            <img
              src={contentData?.coverPhotoUrl || "/assets/icons/discover.png"}
              alt="discover"
              style={{ width: "100%", maxWidth: "253px", height: "auto" }}
            />
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Typography
              fontWeight={500}
              fontSize={{ xs: 20, sm: 24, md: 28 }}
              color={"#233F91"}
            >
              {contentData.title}
            </Typography>
            <Box display={"flex"} flexWrap="wrap" gap={1}>
              <Box display={"flex"} flexWrap="wrap" gap={1}>
                {Array.isArray(contentData.category) ? contentData.category.map((cat, index) => (
                  <Button key={index} variant="contained" sx={styleSheet.btnPsychotherapy}>
                    {cat}
                  </Button>
                )) : (
                  <Button variant="contained" sx={styleSheet.btnPsychotherapy}>
                    {contentData.category}
                  </Button>
                )}
              </Box>

              {/* <Button variant="contained" sx={styleSheet.btnPsychotherapy}>
                {contentData.category[0]}
              </Button>
              <Button variant="contained" sx={styleSheet.btnPsychotherapy}>
                {contentData.category[1]}
              </Button>
              <Button variant="contained" sx={styleSheet.btnPsychotherapy}>
                {contentData.category[2]}
              </Button> */}
            </Box>
            <Box display={"flex"} gap={1}>
              <img src="/assets/icons/discoverUser.png" alt="discover" />
              <Typography fontWeight={400} fontSize={17} color={"#676767"}>
                {contentData.type}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          className="custom-scrollbar"
          sx={{ maxHeight: "500px", overflowY: "scroll", padding: "16px" }}
        >
          <Typography
            fontWeight={500}
            fontSize={{ xs: 20, sm: 24, md: 28 }}
            color={"#233F91"}
          >
            What to expect from this educational content
          </Typography>

          <Box sx={styleSheet.textContainer}>
            <Typography sx={styleSheet.text}>{contentData.summary}</Typography>

          </Box>
        </Box>

        <Box display={"flex"} justifyContent={"center"} mt={5}>
          <Button
            onClick={() => handleEducationContent(contentData.id)}
            variant="contained"
            sx={styleSheet.btnPurchase}
          >
            Purchase this Content
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ReceiptData;

const styleSheet = {
  mainContainer: {
    p: { xs: 2, sm: 3, md: 5 },
    width: { xs: "90%", sm: "100%", md: "802px" },
    margin: "auto",
  },
  container: {
    margin: "auto",
    padding: { xs: "20px", sm: "30px", md: "40px" },
    border: "1px solid #ccc",
    borderRadius: "15px",
    backgroundColor: "#fff",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
  },
  boxContainer: {
    display: "flex",
    gap: { xs: 2, md: 5 },
    mt: { xs: 2, md: 0 },
    marginBottom: "16px",
    borderRadius: "8px 8px 0 0",
    flexDirection: { xs: "column", md: "row" },
  },
  btnPsychotherapy: {
    bgcolor: "#233F91",
    color: "#EDEDED",
    borderRadius: "15px",
    fontSize: { xs: "11px", sm: "14px" },
    fontWeight: 700,
    width: "auto", // Allow the button to expand based on content
    minWidth: "90px", // Ensure small buttons don't get too small
    padding: "6px 10px", // Standard padding
    height: "auto", // Adjust height dynamically
    textAlign: "center",
    whiteSpace: "nowrap", // Prevent text from wrapping
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 2,
  },
  text: {
    fontWeight: 400,
    fontSize: { xs: 16, sm: 18 },
    color: "#565656",
  },
  btnPurchase: {
    bgcolor: "#233F91",
    color: "#fff",
    borderRadius: "15px",
    fontSize: { xs: "14px", sm: "16px" },
    fontWeight: 700,
    width: { xs: "100%", sm: "90%", md: "466px" },
    height: "48px",
  },
};
